import { ComplianceDocumentType } from "src/utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { vendorPreserve } from "../../../_shared/preserve";
import { siiSimplifiedInvoiceSchema } from "./schema";

export const siiSimplifiedInvoiceConfig = defineForm({
  id: "sii_simplified_invoice",
  createEndpoint: MANUAL_DOC_ENDPOINTS.SII_SIMPLIFIED_INVOICE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "Invoice",
  accountClass: "AccountReceivable",
  taxRatesChannel: "SII",
  invoiceType: "simplifiedInvoice",
  complianceType: ComplianceDocumentType.SimplifiedInvoice,
  requiresLegalRep: true,
  titleKey: "simplified_invoice",
  complianceStandardKey: "sii",
  schema: siiSimplifiedInvoiceSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: {
      hiddenFields: [
        "customerCompanyID",
        "customerCountry",
        "customerCompanyStreet",
        "customerCompanyStreetNumber",
        "customerCompanyLocality",
        "customerCompanyRegion",
        "customerCompanyZipCode",
      ],
    },
  },
  omitFromPayload: [
    "customerCompanyID",
    "customerCountry",
    "customerCompanyStreet",
    "customerCompanyStreetNumber",
    "customerCompanyLocality",
    "customerCompanyRegion",
    "customerCompanyZipCode",
  ],
  hiddenCustomerFields: [
    "customerCompanyID",
    "customerCountry",
    "customerCompanyStreet",
    "customerCompanyStreetNumber",
    "customerCompanyLocality",
    "customerCompanyRegion",
    "customerCompanyZipCode",
  ],
});
